import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=0cade546"
import script from "./CreateDialog.vue?vue&type=script&lang=js"
export * from "./CreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports